import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { getContactNameOrCompanyName } from 'flow/utils/contact-utils';
import { TicketKey } from 'flow/types/EntityKeys';
import { twMerge } from 'tailwind-merge';
import ContactTypeIcon from 'flow/components/contact/ContactTypeIcon';
import PhoneNumber from 'flow/components/ui-components/PhoneNumber';
import {
    selectOriginDTOSubtype,
    selectVisitorContact,
    selectVisitorDisplayName,
} from 'flow/selectors/TicketsSelectors';
import { originContactIsPhoneNumber } from 'flow/utils/ticket-channel-utils';

interface Props {
    ticketKey: TicketKey;
    useBold?: boolean;
    colorBackplates?: string;
    // De-emphasise the name (regular weight, mid-gray) — closed tickets.
    muted?: boolean;
}

const ContactItem = ({ ticketKey, useBold, colorBackplates, muted }: Props) => {
    const displayName = useAppSelector((state) =>
        selectVisitorDisplayName(state, ticketKey),
    );
    const originDtoSubtype = useAppSelector((state) =>
        selectOriginDTOSubtype(state, ticketKey),
    );
    const visitorContact = useAppSelector((state) =>
        selectVisitorContact(state, ticketKey),
    );

    return (
        <>
            <div
                className={twMerge(
                    'line-clamp-1 text-base/5 break-all',
                    muted
                        ? 'text-gray-500'
                        : useBold
                          ? 'font-bold text-gray-800'
                          : null,
                )}
            >
                {getContactNameOrCompanyName(visitorContact) ||
                    (originContactIsPhoneNumber(originDtoSubtype) ? (
                        <PhoneNumber number={displayName} />
                    ) : (
                        displayName
                    ))}
            </div>
            <ContactTypeIcon
                contact={visitorContact}
                className={twMerge('group-hover:bg-gray-300', colorBackplates)}
            />
        </>
    );
};

export default React.memo(ContactItem);
